module.exports = "<div class=\"embedded-html\" id=\"embedded-html\">\n    <div id=\"embedded-content\" #embedContainer [innerHTML]=\"sanitizedHtml\"></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/partials/embedded-html/embedded-html.component.html
// module id = ./src/app/partials/embedded-html/embedded-html.component.html
// module chunks = main